class Drawer {
	constructor(drawerEl) {
		this.currentElement = drawerEl;
		this.cart_info_login_toggle = document.getElementById("cart-info-login-toggle");
		this.loginForm = document.getElementById("cart-info-login");
		this.formTermsLink = this.currentElement.querySelector('.Form__CheckboxWrapper label[for="terms"] a');
		this.lastWidth = window.innerWidth;
		this.loginStatus = drawerEl.getAttribute('is-user-logged-in');
		this.cartEls = {
			drawerHeader: drawerEl.querySelector('.Drawer__Header'),
			drawerFooter: drawerEl.querySelector('.Drawer__Footer')
		}

		if (this.formTermsLink) this.formTermsLink.addEventListener('click', this.activateFormTermsLinkModal);
		this.init();

		const _this = this;
		window.addEventListener('rendered-cart', function () {
			setTimeout(() => {
				_this.formTermsLink = drawerEl.querySelector('.Form__CheckboxWrapper label[for="terms"] a');
				_this.formTermsLink.addEventListener('click', _this.activateFormTermsLinkModal);
			}, 1000);
		});
	}

	init() {
		if (this.loginStatus == 'false' && document.querySelector('.Cart__Klub')) this.forgotYourPasswordLogic(drawerEl);
		setTimeout(() => {
			this.handleResize();
		}, 2000);
		const debouncedCheckResize = this.debounce(this.checkResize.bind(this), 200);
		window.addEventListener('resize', debouncedCheckResize);
		this.onCartAction();

	}


	async onCartAction() {
		const outerThis = this;
		window.addEventListener('rendered-cart', () => {
			setTimeout(async () => {
				outerThis.handleResize();
			}, 1000);
		});
	}

	forgotYourPasswordLogic(drawerEl) {
		const customerLoginForm = drawerEl.querySelector('.Cart__Klub #customer_login');
		const recoverPasswordForm = drawerEl.querySelector('.Cart__Klub #recover_customer_password');
		if (!customerLoginForm || !recoverPasswordForm) return;
		const toggleRecoverForm = drawerEl.querySelectorAll('[data-action="toggle-recover-form"]');
		if (!toggleRecoverForm) return;
		toggleRecoverForm.forEach(el => el.addEventListener('click', function (ev) {
			customerLoginForm.classList.toggle('d-none');
			recoverPasswordForm.classList.toggle('d-none');
		}))

	}

	checkResize() {
		const currentWidth = window.innerWidth;
		if (Math.abs(currentWidth - this.lastWidth) >= 10) {
			this.lastWidth = currentWidth;
			this.handleResize();
		}
	}
	handleResize() {
		let viewportHeight = 0;
		viewportHeight = window.visualViewport.height;

		if (!this.cartEls.drawerHeader || !this.cartEls.drawerFooter) return;
		const drawerFooterHeight = drawerEl.querySelector('.Drawer__Footer').offsetHeight;
		if (isNaN(drawerFooterHeight) || drawerFooterHeight === null) return;
		const drawerHeaderHeight = drawerEl.querySelector('.Drawer__Header').offsetHeight;
		if (isNaN(drawerHeaderHeight) || drawerHeaderHeight === null) return;

		let heightFromAdditionalElement = 0;
		if (this.loginStatus === 'false') {
			const cartKlub = document.querySelector('.Cart__Klub');
			if (cartKlub) {
				heightFromAdditionalElement = cartKlub.offsetHeight;
				if (isNaN(heightFromAdditionalElement) || heightFromAdditionalElement === null) return;
			}
		}
		const drawerContent = document.querySelector(`#sidebar-cart[is-user-logged-in=${this.loginStatus}] .Drawer__Main .Drawer__Container`);
		if (!drawerContent) return;
		let drawerSpace = 0;
		drawerSpace = drawerHeaderHeight + drawerFooterHeight + heightFromAdditionalElement;
		const extraSpacing = '10px';
		drawerContent.setAttribute('style', `max-height: calc(${viewportHeight}px - ${drawerSpace}px - ${extraSpacing});`);
	}

	debounce(func, delay) {
		let timeoutId;
		return function (...args) {
			if (timeoutId) {
				clearTimeout(timeoutId);
			}
			timeoutId = setTimeout(() => {
				func.apply(this, args);
			}, delay);
		};
	}

	activateFormTermsLinkModal(event) {
		event.preventDefault();
		document.querySelector('.checkout-confirmation-modal.modal-overlay').classList.add('modal-overlay-active');
	}
}

const drawerEl = document.querySelector('#sidebar-cart');
if (drawerEl) {
	new Drawer(drawerEl);
}


